/* eslint-disable array-callback-return */
import {useEffect, useState} from 'react';
import SegnalazioneCreateSubsection from "./SegnalazioneCreateSubsection";
import SegnalazioneCreateSubsectionOrdine from "./SegnalazioneCreateSubsectionOrdine";
import { Section } from '../../../services/models/objs/StorSection';

type SegnalazioneCreateSectionType = {
    segnalazioneChoiceLists : any,
    notificationFunctions : any,
    setNewSegnalazione : any,
    fieldIsRequiredAndMissing : any,
    newStorHasFieldMissing : any,
    errorClickingNextSection : boolean,
    newSegnalazione : {[key : string] : any},
    storSectionStructure : Section
}

const SegnalazioneCreateSection = ({
                                       segnalazioneChoiceLists,
                                       notificationFunctions,
                                       setNewSegnalazione,
                                       fieldIsRequiredAndMissing,
                                       newStorHasFieldMissing,
                                       errorClickingNextSection,
                                       newSegnalazione,
                                       storSectionStructure} : SegnalazioneCreateSectionType) => {

    const [showSubsections, setShowSubsections] = useState<{[key : string] : any}>({})

    useEffect(() => {
        initShowSubsections()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []) // [] means run only ones

    function initShowSubsections() {
        const tmpShowSubsections : {[key : string] : any}= {}
        storSectionStructure.subSections.map(subSection => {
            tmpShowSubsections[subSection.id] = true
        })
        setShowSubsections(tmpShowSubsections)
    }

    function toggleShowSubSection(subsectionName : string) {
        const tmpShowSubsections : {[key : string] : any} = {}
        Object.assign(tmpShowSubsections, showSubsections)
        tmpShowSubsections[subsectionName] = !tmpShowSubsections[subsectionName]
        setShowSubsections(tmpShowSubsections)
    }

    function isSpecialSubsection(subsection : string) {
        if (subsection === 'descrizioneOrdine' || subsection === 'dataOraOrdine' || subsection === 'nazione')
            return true
        return false
    }

    return (
        <div className="mt-5">
            {storSectionStructure.subSections.map(subSection => {
                return <div key={subSection.id} className="mt-4 row shadow card-body">
                    <div className="font-medium-custom text-bold col-10 my-auto">
                        <span className="margin-right-5">{subSection.name}</span>
                        {/* <Tooltip placement="bottom" title={subSection.description} arrow>
                            <InfoOutlinedIcon tooltip={subSection.description} className="color-primary"/>
                        </Tooltip> */}
                    </div>
                    <div className="text-align-end text-bold font-medium-custom color-primary my-auto col-2">
                        <span onClick={() => {toggleShowSubSection(subSection.id)}} className="pointer my-auto">
                            {showSubsections[subSection.id] ? "Nascondi campi" : "Mostra campi"}
                        </span>
                    </div>
                    {showSubsections[subSection.id] && subSection.id === 'dataOraOrdine' ? <SegnalazioneCreateSubsectionOrdine
                        segnalazioneChoiceLists={segnalazioneChoiceLists}
                        notificationFunctions={notificationFunctions}
                        setNewSegnalazione={setNewSegnalazione}
                        fieldIsRequiredAndMissing={fieldIsRequiredAndMissing}
                        newStorHasFieldMissing={newStorHasFieldMissing}
                        errorClickingNextSection={errorClickingNextSection}
                        newSegnalazione={newSegnalazione}
                        storSectionName={storSectionStructure.id}
                        storSubsectionStructure={subSection}
                    />: <></>}
                    {showSubsections[subSection.id] && subSection.id === 'nazione' ? <SegnalazioneCreateSubsectionOrdine
                        segnalazioneChoiceLists={segnalazioneChoiceLists}
                        notificationFunctions={notificationFunctions}
                        setNewSegnalazione={setNewSegnalazione}
                        fieldIsRequiredAndMissing={fieldIsRequiredAndMissing}
                        newStorHasFieldMissing={newStorHasFieldMissing}
                        errorClickingNextSection={errorClickingNextSection}
                        newSegnalazione={newSegnalazione}
                        storSectionName={storSectionStructure.id}
                        storSubsectionStructure={subSection}
                    />: <></>}
                    {showSubsections[subSection.id] && subSection.id === 'descrizioneOrdine' ? <SegnalazioneCreateSubsectionOrdine
                        segnalazioneChoiceLists={segnalazioneChoiceLists}
                        notificationFunctions={notificationFunctions}
                        setNewSegnalazione={setNewSegnalazione}
                        fieldIsRequiredAndMissing={fieldIsRequiredAndMissing}
                        newStorHasFieldMissing={newStorHasFieldMissing}
                        errorClickingNextSection={errorClickingNextSection}
                        newSegnalazione={newSegnalazione}
                        storSectionName={storSectionStructure.id}
                        storSubsectionStructure={subSection}
                    />: <></>}
                    {showSubsections[subSection.id] && !isSpecialSubsection(subSection.id)? <SegnalazioneCreateSubsection
                        segnalazioneChoiceLists={segnalazioneChoiceLists}
                        notificationFunctions={notificationFunctions}
                        setNewSegnalazione={setNewSegnalazione}
                        fieldIsRequiredAndMissing={fieldIsRequiredAndMissing}
                        newStorHasFieldMissing={newStorHasFieldMissing}
                        errorClickingNextSection={errorClickingNextSection}
                        newSegnalazione={newSegnalazione}
                        storSectionName={storSectionStructure.id}
                        storSubsectionStructure={subSection}
                    /> : <></>}
                </div>
            })}

        </div>
    )
}

export default SegnalazioneCreateSection;


// TBD tooltip